import React, { FunctionComponent } from "react";
import { connect } from "react-redux";

import "../../../css/nav_bar/nav_bar_controls.css";
import getPageName from "../../services/getters/location_metadata/get_page_name";
import NavBarControlsExplorer from "./nav_bar_controls_explorer";
import NavBarKebabMenu from "./nav_bar_kebab_menu";
import NavBarManageUsersIcon from "./nav_bar_manage_users_icon";
import PageNames from "../../models/domain/enums/page_names";
import NavBarControlsWbs from "./nav_bar_controls_wbs";
import NavBarPanelsMenu from "./nav_bar_panels_menu";
import { useFlags } from "../../services/utilities/launch_darkly_helper";


export type Props = ReturnType<typeof mapStateToProps>;

export const NavPageControls: FunctionComponent<Props> = (props) => {
  const { pageName } = props;
  const { customerFacingManageUsers, dataDashboard } = useFlags();

  let pageControls = null;
  switch(pageName) {
    case PageNames.PROJECT_VIEWER:
      pageControls = <NavBarControlsExplorer/>;
      break;
    case PageNames.BUDGET:
      pageControls = <NavBarControlsWbs/>
      break;
    case PageNames.PROJECT_SUMMARY:
      pageControls = <>
        <NavBarPanelsMenu/>
        {customerFacingManageUsers && <NavBarManageUsersIcon/>}
        <NavBarKebabMenu/>
      </>
      break;
    case PageNames.DASHBOARD:
      if (dataDashboard) {
        pageControls = <>
          <NavBarPanelsMenu/>
          {customerFacingManageUsers && <NavBarManageUsersIcon/>}
          <NavBarKebabMenu/>
        </>;
      } else {
        pageControls = <>
          {customerFacingManageUsers && <NavBarManageUsersIcon/>}
          <NavBarKebabMenu/>
        </>;
      }
      break;
    default:
      pageControls = <>
        {customerFacingManageUsers && <NavBarManageUsersIcon/>}
        <NavBarKebabMenu/>
      </>;
  }
  return <div className="NavBarControls">
    {!customerFacingManageUsers && <NavBarManageUsersIcon/>}
    {pageControls}
  </div>;
};

const mapStateToProps = (state, props) => ({
  pageName: getPageName(state, props),
});

export default connect(mapStateToProps)(NavPageControls);
